module.exports = [{"code":"en","text":"English"},{"code":"zh","text":"中文"},{"code":"ja","text":"日本語"},{"code":"fr","text":"Français"},{"code":"es","text":"Español"},{"code":"id","text":"Indonesia"}]


//////////////////
// WEBPACK FOOTER
// ./data/allLanguages.json
// module id = 423
// module chunks = 230186691558513